import React from 'react';
import useSiteState from '../components/hooks/useSiteState';
import { SiteContext } from './SiteContext';

type SiteProviderProps = {
    children: React.ReactNode;
};

const SiteProvider = ({ children }: SiteProviderProps): JSX.Element => {
    const {
        brandId,
        brandStyles,
        brandSearchComplete,
        clientId,
        domain,
        audience,
        features,
        language
    } = useSiteState();

    return (
        <SiteContext.Provider
            value={{
                brandId,
                brandStyles,
                brandSearchComplete,
                clientId,
                domain,
                audience,
                features,
                language
            }}>
            {children}
        </SiteContext.Provider>
    );
};

export default SiteProvider;
